import { If } from 'components/Common/If/If'
import { BoMItemBadge } from 'features/BillOfMaterials/BoMItemBadge/BoMItemBadge'
import { BoMItemBadgeList } from 'features/BillOfMaterials/BoMItemBadge/BoMItemBadgeList'
import { bomItemExportedToErpSelector } from 'features/BillOfMaterials/store/selectors/bomItemExportedToErpSelector'
import { bomItemManufacturabilitySelector } from 'features/BillOfMaterials/store/selectors/bomItemManufacturability'
import { isEqual } from 'lodash'
import { RunnableTaskStatus } from 'model/Project/BoMItemRow'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'

export const BadgeList = ({ bomItemId }: { bomItemId: string }) => {
  const { t } = useTranslation()

  const manufacturability = useAppSelector(
    bomItemManufacturabilitySelector(bomItemId),
    isEqual
  )
  const exported = useAppSelector(
    bomItemExportedToErpSelector(bomItemId),
    isEqual
  )

  if (
    exported.exportedStatus === 'NotApplicable' &&
    manufacturability.status === 'NotApplicable'
  ) {
    return null
  }

  return (
    <BoMItemBadgeList alwaysVisible>
      <If condition={manufacturability.status !== 'NotApplicable'}>
        <BoMItemBadge
          status={manufacturability.status as RunnableTaskStatus}
          category={t(
            'project:badge-category-manufacturability',
            'manufacturability'
          )}
          runningLabel={t(
            `project:runnable-task-status-${manufacturability.status}`,
            manufacturability.status.toLowerCase()
          )}
          running={
            manufacturability.status.toLowerCase() === 'running' ||
            manufacturability.status.toLowerCase() === 'requested'
          }
          finishedLabel={
            manufacturability.isManufacturable
              ? t('project:manufacturable-success', 'manufacturable')
              : t('project:manufacturable-fail', 'not manufacturable')
          }
          title={manufacturability.result}
        />
      </If>
      <If condition={exported.exportedStatus !== 'NotApplicable'}>
        <BoMItemBadge
          status={exported.exportedStatus as RunnableTaskStatus}
          category={t('project:badge-category-erp', 'ERP')}
          runningLabel={t(
            `project:runnable-task-status-${exported.exportedStatus}`,
            exported.exportedStatus.toLowerCase()
          )}
          finishedLabel={
            exported.isExported
              ? t('project:exported-to-erp', 'exported')
              : t('project:exported-to-erp-error', 'not exported')
          }
          running={
            exported.exportedResult?.toLowerCase() === 'running' ||
            exported.exportedResult?.toLowerCase() === 'requested'
          }
          title={exported.exportedResult}
        />
      </If>
    </BoMItemBadgeList>
  )
}
